import { ICustomer } from 'dto/users.dto'
import UsersService from 'dataStore/service/users.service'
import { ICustomersListQuery } from 'handlers/buildCustomersQueryParams'

/** Размер порции при выгрузке всех страниц */
export const CUSTOMERS_EXPORT_PAGE_SIZE = 500

interface FetchAllFilteredCustomersParams {
  /** Базовый query без limit/offset (фильтры и сортировка) */
  baseQuery: Omit<ICustomersListQuery, 'limit' | 'offset'>
  /** Размер одной порции */
  pageSize?: number
}

/**
 * Загружает всех клиентов по фильтрам и сортировке, обходя пагинацию.
 * @param params — фильтры/сортировка и размер порции
 * @returns полный список клиентов
 */
export const fetchAllFilteredCustomers = async (
  params: FetchAllFilteredCustomersParams,
): Promise<ICustomer[]> => {
  const pageSize = params?.pageSize ?? CUSTOMERS_EXPORT_PAGE_SIZE
  const allCustomers: ICustomer[] = []
  let offset = 0
  let total = Number.POSITIVE_INFINITY

  while (offset < total) {
    const response = await UsersService.getAllCustomers({
      ...params.baseQuery,
      limit: pageSize,
      offset,
    })

    const pageCustomers = Array.isArray(response?.data) ? response.data : []
    total = typeof response?.total === 'number' ? response.total : pageCustomers.length

    allCustomers.push(...pageCustomers)

    if (pageCustomers.length === 0) {
      break
    }

    offset += pageCustomers.length

    // Защита от зацикливания, если API не увеличивает offset-результаты
    if (pageCustomers.length < pageSize) {
      break
    }
  }

  return allCustomers
}
